module.exports = __webpack_public_path__ + "img/rlogo.f539a4c9.jpg";